export default __webpack_public_path__ + "static/media/how-to-apply-env-audit.231a7221.jpeg";